export { default } from './Slider';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Slider/index.js
// module id = 350
// module chunks = 0